import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Terms of Service"
        description="Ledger Terms of Service. Review the terms and conditions governing your use of our platform."
        canonical="/terms"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-surface-900 mb-4">Terms of Service</h1>
          <p className="text-lg text-surface-600">Last updated: January 2026</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

